;globalThis["_sentryRewritesTunnelPath"] = "/monitoring-tunnel";globalThis["SENTRY_RELEASE"] = {"id":"3bdf790a14a9681792603a4b6a5700bfcf2b777c"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import * as Sentry from '@sentry/nextjs';

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  tracePropagationTargets: ['localhost', /^https:\/\/app\.fisify\.com/],
  environment: process.env.NODE_ENV,
  tracesSampleRate: 1.0,
  replaysOnErrorSampleRate: 1.0,

  // Filter out specific errors before sending to Sentry
  beforeSend(event) {
    // ---- FIREBASE MESSAGING ERRORS ----
    const firebaseMessagingErrors = [
      "Messaging: This browser doesn't support the API's required to use the Firebase SDK. (messaging/unsupported-browser)",
      'messaging/unsupported-browser',
      "FirebaseError: This browser doesn't support the API's required to use the Firebase SDK.",
      'Firebase: Error (auth/network-request-failed)',
    ];

    // ---- NETWORK ERRORS ----
    const networkErrorPatterns = [
      'Network Error',
      'Failed to fetch',
      'NetworkError',
      'The Internet connection appears to be offline',
      'The network connection was lost',
    ];

    // ---- HYDRATION ERRORS ----
    const hydrationErrorPatterns = [
      'Hydration failed because the initial UI does not match what was rendered on the server.',
      'There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering.',
    ];

    // Check if the error is a Firebase messaging error
    const isFirebaseMessagingError = event.exception?.values?.some(
      (exception) =>
        firebaseMessagingErrors.some((errorPattern) => exception.value?.includes(errorPattern)) ||
        (exception.type === 'FirebaseError' && exception.value?.includes('messaging/unsupported-browser')),
    );

    // If it's a Firebase messaging error, don't send to Sentry
    if (isFirebaseMessagingError) {
      return null;
    }

    // Check if the error is a network error
    const isNetworkError = event.exception?.values?.some(
      (exception) =>
        (exception.type === 'Error' && exception.value === 'Network Error') ||
        networkErrorPatterns.some((pattern) => exception.value?.includes(pattern)),
    );

    // Sample network errors (only send 10% of them) to reduce noise
    if (isNetworkError) {
      // Random sampling - only send 10% of network errors
      if (Math.random() > 0.1) {
        return null;
      }
    }

    // Check if the error is a hydration error
    const isHydrationError = event.exception?.values?.some((exception) =>
      hydrationErrorPatterns.some((pattern) => exception.value?.includes(pattern)),
    );

    // If it's a hydration error, don't send to Sentry
    if (isHydrationError) {
      return null;
    }

    // Send all other events to Sentry
    return event;
  },

  // Ignore specific error patterns
  ignoreErrors: [
    // Firebase messaging errors
    "Messaging: This browser doesn't support the API's required to use the Firebase SDK. (messaging/unsupported-browser)",
    'messaging/unsupported-browser',
    "FirebaseError: Messaging: This browser doesn't support",
    /Firebase.*messaging\/unsupported-browser/,
    /Messaging: This browser doesn't support/,
    'Firebase: Error (auth/network-request-failed)',
    /Firebase.*auth\/network-request-failed/,
    // Hydration errors
    'Hydration failed because the initial UI does not match what was rendered on the server.',
    'There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering.',

    // Network error patterns
    'Network Error',
    'Failed to fetch',
    /The Internet connection appears to be offline/,
    /The network connection was lost/,
  ],
});
